module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"chart-type:type-1":"Pie","chart-type:type-2":"Doughnut"},"en":{"chart-type:type-1":"Pie","chart-type:type-2":"Doughnut"}}')
  delete Component.options._Ctor
}
